module.exports = __webpack_public_path__ + "media/images/riders/small/ELLEN_NOBLE-291e8a6a56c10cd9a216a39da3b8d186.png";